import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FC } from 'react';

//components
import { Divider } from 'Components/shared';
import FooterBanner from './footer-banner';
import FooterCsr from './footer-csr-menu';
import FooterLegal from './footer-legal';
import FooterMasthead from './footer-masthead';
import StayConnected from './footer-stay-connected';
import FooterPrivacyPolicy from './footer-privacy-policy';
import CondensedFooterContent from './condensed-footer-content';

//styles
import styles from './footer.module.scss';

interface IFooterProps {
  displayCondensedFooter?: boolean;
}

const Footer: FC<IFooterProps> = ({ displayCondensedFooter }) => {
  return (
    <footer className={clsx(styles.footer, displayCondensedFooter && styles.stickyFooter)}>
      {displayCondensedFooter ? (
        <>
          <Divider customClass={styles.divider} />
          <CondensedFooterContent />
        </>
      ) : (
        <>
          <FooterPrivacyPolicy />
          <FooterBanner />
          <FooterCsr />
          <StayConnected />
        </>
      )}
      <FooterMasthead />
      <FooterLegal />
    </footer>
  );
};

Footer.propTypes = {
  displayCondensedFooter: PropTypes.bool,
};

export default Footer;
